'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@radix-ui/react-popover/dist/index.cjs');
var Content_web = require('./Content/Content.web.cjs');
var Trigger_web = require('./Trigger/Trigger.web.cjs');

/**
 *
 */ const Popover = ({ // isOpen,
// openAction = "click",
// hoverCloseDelay = 150,
// triggerCallback,
children })=>{
    // const [isPopoverOpen, setIsPopoverOpen] = useControlledState(!!isOpen, {
    //   value: isOpen,
    //   setValue: triggerCallback,
    // });
    // useEffect(() => {
    //   setOpenAction(openAction);
    // }, [openAction]);
    // const { isContentHovered } = usePopoverInternalVars();
    // const timeoutRef = useRef(null);
    // const servicesRef = useRef(null);
    // const isServicesHovered = useHover(servicesRef);
    // useEffect(() => {
    //   if (openAction === "hover") {
    //     if (isServicesHovered) {
    //       setIsPopoverOpen(true);
    //       if (triggerCallback) triggerCallback(true);
    //       clearTimeout(timeoutRef.current);
    //     } else if (isPopoverOpen && !isContentHovered) {
    //       timeoutRef.current = setTimeout(() => {
    //         setIsPopoverOpen(false);
    //         if (triggerCallback) triggerCallback(false);
    //       }, hoverCloseDelay);
    //     }
    //   }
    // }, [isServicesHovered, isContentHovered]);
    // if ((openAction === "hover" && !isOpen) || isOpen !== null) {
    //   return (
    //     <div ref={servicesRef}>
    //       <Root open={isPopoverOpen}>{children}</Root>
    //     </div>
    //   );
    // }
    return /*#__PURE__*/ jsxRuntime.jsx(index.Root, {
        children: children
    });
};
Popover.Trigger = Trigger_web.Trigger;
Popover.Content = Content_web.Content;

exports.Popover = Popover;
//# sourceMappingURL=Popover.web.cjs.map
